<template>
  <div class="home">
    <Header />
    <div class="main-img d-flex ai-center">
      <img src="../assets/main-moon.png" v-if="isDark" />
      <img src="../assets/main-sun.png" v-else />
    </div>
    <div class="box-bg-2 search-input border-bg d-flex ai-center">
      <input
        class="text-gray-1 flex-1 box-bg-2"
        type="text"
        :placeholder="$t('placeholder')"
        v-model="hash"
        @keydown.enter="goHash"
        autocomplete="off"
      />
      <img
        class="delete"
        :src="deleteImg"
        v-if="hash !== ''"
        @click="hash = ''"
        style=""
      />
      <div
        class="button search-button-bg d-flex ai-center jc-center"
        @click="goHash"
      >
        <img class="loading" src="../assets/loading.png" v-if="isLoading" />
        <img src="../assets/search.png" v-else />
      </div>
    </div>
    <!-- <Toast v-if="isToast" @closeToast="closeToast" /> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '../components/Header.vue'
// import Toast from '../components/Toast.vue'

export default {
  name: 'Home',
  components: { Header },
  data() {
    return {
      hash: '',
      isLoading: false,
      isToast: false,
    }
  },

  computed: {
    ...mapGetters(['isDark']),
    deleteImg() {
      let str = ''
      this.isDark ? (str = '-dark') : ''
      return require(`../assets/delete${str}.png`)
    },
  },
  // created() {
  //   const { hash } = this.$route.query
  //   if (hash) {
  //     this.hash = hash
  //     this.getTransitDetails()
  //   }
  // },

  methods: {
    closeToast() {
      this.isToast = false
    },
    goHash() {
      if (!this.hash.trim()) {
        return
      }
      this.$router.push({
        path: `/hash/${encodeURIComponent(this.hash)}`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@keyframes rotate {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(180deg);
  }
}
.home {
  width: 9rem;
  margin: 0 auto;
  .main-img {
    margin-top: 0.8rem;
    img {
      width: 3.35rem;
      height: 1.6rem;
      margin: 0 auto;
    }
  }
  .search-input {
    margin-top: 0.3rem;
    height: 0.78rem;
    padding: 0 0.1rem 0 0.5rem;
    border-width: 0.01rem;
    border-style: solid;
    border-radius: 0.24rem;
    input {
      border: none;
      outline: none;
      font-size: 0.16rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
    }
    .delete {
      cursor: pointer;
      width: 0.2rem;
      height: 0.2rem;
      margin: 0 0.2rem;
    }
    .button {
      width: 0.58rem;
      height: 0.58rem;
      border-radius: 0.16rem;
      cursor: pointer;
      img {
        width: 0.28rem;
        height: 0.28rem;
      }
      .loading {
        animation: rotate 1s linear infinite;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .home {
    width: 100%;
    padding: 0 0.32rem;
    .main-img {
      margin-top: 1.29rem;
      img {
        width: 85%;
        height: auto;
      }
    }
    .search-input {
      margin-top: 0.4rem;
      height: 0.88rem;
      input {
        font-size: 0.24rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .delete {
        width: 0.32rem;
        height: 0.32rem;
        margin: 0 0.3rem;
      }
      .button {
        width: 0.68rem;
        height: 0.68rem;
        // border-radius: 0.16rem;
      }
    }
  }
}
</style>
